import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import store from "./store";
import history from "./history";
import Layouts from "./layouts";
import { THEME_CONFIG } from "./configs/AppConfig";
import "./lang";
import WebSocketProvider from "context/websocket/webProvider";
import TourProvider from "context/tour/tourProvider";
import VudioProvider from "context/vudio/vudioProvider";
import { ReactFlowProvider } from "@xyflow/react";
import AIVideoEditorProvider from "context/vudio/AiVideoEditor/aiVideoEditorProvider";
const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

const environment = process.env.NODE_ENV;

function App() {
  return (
    <div className="App">
      <ReactFlowProvider>
        <AIVideoEditorProvider>
          <VudioProvider>
            <WebSocketProvider>
              <Provider store={store}>
                <TourProvider>
                  <BrowserRouter history={history}>
                    <ThemeSwitcherProvider
                      themeMap={themes}
                      defaultTheme={THEME_CONFIG.currentTheme}
                      insertionPoint="styles-insertion-point"
                    >
                      <Layouts />
                    </ThemeSwitcherProvider>
                  </BrowserRouter>
                </TourProvider>
              </Provider>
            </WebSocketProvider>
          </VudioProvider>
        </AIVideoEditorProvider>
      </ReactFlowProvider>
    </div>
  );
}

export default App;
